import {AppStore} from "../../useAppPullState";
import {toast} from "react-toastify";
import {getUserBookings as apiCall} from "../../api/members";

export const getUserParamsSelector = s => {
    return ({
        memberId: s.user?.SgsMemberId,
        password: s.user?.password,
        adminId: s.user?.userName,
    })

}
function reset() {
    AppStore.update(s => {
        s.unavailableCourses = null;
        // console.log('[[sync user bookings]]', {unavailableCourses: null})
        s.userInAdvanceBookings = null
        s.userTodayBookings = null
    })
}

function toDate(a) {
    if(!a.date) {
        return new Error(`No date found in ${a}`);
    }
    return new Date(a.date.split('/').reverse().join('/'));
}

const descByDate = (a, b) => {
    // date is string 19/08/2023
    const aDate = toDate(a);
    const bDate = toDate(b);
    return bDate - aDate;
};

export const mapCoursesToInAdvanceBookings = (courses) => {
    if(courses?.multiYear){
        const {multiYear, ...years} = courses;
        return Object.entries(years).map(([year, courses]) => {
            return Object.entries(courses).map(([courseId, course]) => {
                return {
                    courseId: courseId,
                    ...course,
                }
            })
        }).flat();
    }
    return Object.entries(courses)
        .filter(v => !!v)
        .map(([courseId, course]) => {
        return {
            courseId: courseId,
            ...course,
        }
    })
}


function handleResponse(res) {
    // console.log("[[syncUserBookings]] res", res);
    if (res.status) {
        const unavailableCourses = Array.isArray(res.data.unavailableCourses) ? res.data.unavailableCourses.filter(v => !!v) : res.data.unavailableCourses
        // parse today bookings and sort it by date
        const todayBookings = Object.values(res.data.todayBookings).sort(descByDate);
        const inAdvance = mapCoursesToInAdvanceBookings(unavailableCourses).sort(descByDate);

        // unavailableCourses is an keys (courseId) of unavailableCourses
        // const unavailableCourses = Object.keys(res.data.unavailableCourses);

        //console.log('[[sync user bookings]]', {unavailableCourses})

        AppStore.update(s => {
            s.unavailableCourses = unavailableCourses;
            s.userInAdvanceBookings = inAdvance;
            s.userTodayBookings = todayBookings;
        })
    } else {
        // console.error("Failed to get unavailable courses", res);
        // toast.error("Failed to get unavailable courses");

    }
}

export const deleteInAdvanceBooking = (id) => {
    AppStore.update(s => {
        const deleteItem = s.userInAdvanceBookings.find(item => item.id === id);
        s.userInAdvanceBookings = s.userInAdvanceBookings.filter(item => item.id !== id);

        // console.log('[[sync user bookings]]', {unavailableCourses: s.unavailableCourses})

        // filter object
        s.unavailableCourses = deleteKeyFromObject(deleteItem.courseId, s.unavailableCourses);
    })
}


export const deleteKeyFromObject = (key, obj) => {
    const {[key]: _, ...rest} = obj;
    return rest;
}

export function syncUserBookings() {
    const {memberId, password, adminId} = getUserParamsSelector(AppStore.getRawState())
    reset();
    const isId = memberId || adminId;
    if(isId){
        return apiCall({
            memberId,
            adminId,
            password
        }, handleResponse)
    }

}

export const syncMemberBookings = (memberId) => {
    const store = AppStore.getRawState();
    const {
        password,
        adminId,
    } = getUserParamsSelector(store)
    return apiCall({
        memberId,
        password,
        adminId
    }, handleResponse)
}
